exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cc-status[data-v-cb9fdbd6]{font-size:12px;padding:4px;margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-cb9fdbd6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Status.vue
// module id = 219
// module chunks = 0